import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL } from '../../utils/Constants';

// Async thunk for fetching data
export const fetchForgotpasdAsync = createAsyncThunk('fetchForgotpasdAsync', async (payload) => {
  const config = {
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
    },
  };
  const response = await axios.put(`${BASE_URL}/v1/common/forgotPassword`, payload, config); // Replace with your API endpoint
  return response.data;
});

const ForgotpasdSlice = createSlice({
  name: 'Forgotpasd',

  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearData: (state) => {
      state.data = null;
      state.error = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchForgotpasdAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchForgotpasdAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchForgotpasdAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default ForgotpasdSlice.reducer;
export const { clearData } = ForgotpasdSlice.actions;